/**
 * 站点配置
 * 域名优先从 .env 的 VITE_APP_BASE_URL 读取，未设置时使用下方默认值
 */
export const SITE_BASE_URL = (typeof import.meta.env !== 'undefined' && import.meta.env.VITE_APP_BASE_URL)
    ? String(import.meta.env.VITE_APP_BASE_URL).replace(/\/$/, '')
    : 'http://www.zhangyuan.click'
